import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import CustomPaper from "src/component/uiElements/customPaper/customPaper";
import PageHeading from "src/component/pageHeading/pageHeading";
import UseCommercialPropertyInformation from "./useCommercialPropertyInformation";

type PgPropertyDetailsScreenProps = {
    list?: any;
};
const CommercialPropertyInformationScreen = ({ list }: PgPropertyDetailsScreenProps) => {
    const {
        financialDetails,
        OwnersDetails,
        propertyDetails,
        mediaDetails,
        infraFacilitiesDetails
    } = UseCommercialPropertyInformation(list);


    return (
        <>
            <CustomPaper>

                <form
                    noValidate
                    style={{ width: "100%" }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <PageHeading firstHeading="Property Measurements" lastHeading="Details" />
                        </Grid>

                        {financialDetails && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <div><strong>Monthly Rent:</strong> {financialDetails.MonthlyRent || "N/A"}</div>
                                </Grid>
                                
                            </>
                        )}
                    </Grid>

                </form>

            </CustomPaper>

            {/* <CustomDualBudgetRangeSlider
        label="Budget Range"
        min={1}
        max={500000}
        value={budgetRange}
        setValue={setBudgetRange}
      /> */}
        </>
    );
};

export default CommercialPropertyInformationScreen;
